import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';
import { PaypalPaymentModal } from '../models/PaypalPayment.model';
import { FinalProductPaymentModal } from '../models/FinalProductPayment.model';
import { stringify } from 'querystring';
import { PaypalTokenModel } from '../models/PaypalToken.model';
import * as MPaypalProductModel from '../models/MPaypalProduct.model';
import { PaypalPlanRequestBodyModel, PlanStatus, billing_cycle, taxes, payment_preferences, money, setup_fee_failure_action, pricing_scheme, frequency, interval_unit, tenure_type } from '../models/PaypalPlanRequestBodyModel.model';
import { PayPalPlan } from '../models/PaypalPlan.model';
import { DatePipe } from '@angular/common';
import { PaypalBaseurl } from '../../../connectionString';

@Injectable()
export class PaypalManagementService {

  constructor(private http: HttpClient) { }
  getProducts() {
    var Headers = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.get(globalAdd.Paneladdress + 'api/IPS/BuyProduct/getProducts', { headers: Headers });
  }

  getSingleSelectedProduct(productId) {
    var Headers = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(globalAdd.Paneladdress + 'api/IPS/BuyProduct/getSingleSelectedProduct', { productId: productId }, { headers: Headers });
  }

  applyPromoCode(productId, PromoCode, ProductQuantity) {
    var Headers = new HttpHeaders({ 'No-Auth': 'True' });
    // return this.http.get(globalAdd.Paneladdress + 'api/IPS/BuyProduct/applyPromoCode?productId='+productId+'&PromoCode='+PromoCode+'&ProductQuantity='+ProductQuantity, { headers: Headers });
    return this.http.get(globalAdd.Paneladdress + 'api/IPS/BuyProduct/applyPromoCode?productId=' + productId + '&PromoCode=' + PromoCode + '&ProductQuantity=' + ProductQuantity, { headers: Headers });
  }

  checkEmailIsValid(email: string) {
    var Headers = new HttpHeaders({ 'No-Auth': 'True' });
    //  return this.http.post(globalAdd.Paneladdress + 'api/BuyProduct/UserInformation/checkEmail?email='+ email, { headers: Headers });
    return this.http.get(globalAdd.Paneladdress + 'api/BuyProduct/UserInformation/checkEmail?email=' + email, { headers: Headers });
  }

  createUserAfterPayment(finalModal: FinalProductPaymentModal) {
    var Headers = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(globalAdd.Paneladdress + 'api/BuyProduct/UserInformation/finalProductPayment', finalModal, { headers: Headers });

  }

  getTransactionId(token: string,SuscriptionId:string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token ,
        'paypal': 'true'
      })
    };
   
    var datepipe = new DatePipe(this.getUsersLocale("en-US"));
    var startDate =  new Date;
    var endDate =  new Date;
   
   endDate.setDate(startDate.getDate()+1);
    //let content: HttpParams = new HttpParams().set("grant_type", "client_credentials");
      return this.http.get(PaypalBaseurl +"v1/billing/subscriptions/"+ SuscriptionId + "/transactions?start_time="+datepipe.transform(startDate,"yyyy-MM-dd")+ "T00:00:00.000Z" + "&end_time=" +datepipe.transform(endDate,"yyyy-MM-dd")+ "T07:50:20.940Z ", httpOptions);
  }
  createProductAndPlanForNewHa(haModel: PaypalPaymentModal) {
    var Headers = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(globalAdd.Paneladdress + 'api/IPS/BuyProduct/createPaypalPlanHa', haModel, { headers: Headers });
  }


  savePlan(plan: PayPalPlan) {
    var Headers = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(globalAdd.Paneladdress + 'api/IPS/BuyProduct/savePaypalPlan', plan, { headers: Headers });
  }
  payPalBasicDetails() {
    let Headers = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(globalAdd.Paneladdress + 'api/IPS/BuyProduct/BasicDetails', null, { headers: Headers });
  }

  payPalToken(token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + token ,
        'paypal': 'true'
      })
    };
      let content: HttpParams = new HttpParams().set("grant_type", "client_credentials");
      return this.http.post(PaypalBaseurl+"v1/oauth2/token", content, httpOptions);
  }




  createPaypalProduct(token: string,productModel:MPaypalProductModel.MPaypalProduct) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token ,
        'paypal': 'true'
      })
    };
    //let content: HttpParams = new HttpParams().set("grant_type", "client_credentials");
      return this.http.post(PaypalBaseurl+"v1/catalogs/products", productModel, httpOptions);
  }

  createPaypalPlan(token: string,ProductId: string,PlanName:string,PlanDesc:string,TrialValue :number,FixedValue:number){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token ,
        'paypal': 'true'
      })
    };

    var billingCycle1 = new billing_cycle(new pricing_scheme(new money("USD",TrialValue.toFixed(2).toString())),
    new frequency("MONTH",1),
    "TRIAL",
    1,
    1
    );
    var billingCycle2 = new billing_cycle(new pricing_scheme(new money("USD",FixedValue.toFixed(2).toString())),
    new frequency("MONTH",1),
    "REGULAR",
    2,
    11
    );
   
 var PlanModel = new PaypalPlanRequestBodyModel();
 PlanModel.id = null;
 PlanModel.product_id=ProductId;
 PlanModel.name=PlanName;
 PlanModel.description = PlanDesc;
 PlanModel.status = "ACTIVE";
 PlanModel.quantity_supported = false;
 PlanModel.billing_cycles= [billingCycle1,billingCycle2]
 PlanModel.taxes = new taxes("6.25",true);
 PlanModel.payment_preferences = new payment_preferences(false,new money("USD","0"),"CONTINUE",0);
 
 var nJsRes = JSON.stringify(PlanModel)



 
//  PlanModel.billing_cycles.push(new billing_cycle(new pricing_scheme(new money("USD",Math.round(TrialValue).toString())),
//  new frequency(interval_unit.MONTH.toString(),1),
//  tenure_type.TRIAL.toString(),
//  1,
//  1
//  ));

//  PlanModel.billing_cycles.push(new billing_cycle(new pricing_scheme(new money("USD",Math.round(FixedValue).toString())),
//  new frequency(interval_unit.MONTH.toString(),1),
//  tenure_type.REGULAR.toString(),
//  2,
//  11
//  ));

      return this.http.post(PaypalBaseurl+"v1/billing/plans", nJsRes, httpOptions);
  }

  getUsersLocale(defaultValue: string): string {
    if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
      return defaultValue;
    }
    const wn = window.navigator as any;
    let lang = wn.languages ? wn.languages[0] : defaultValue;
    lang = lang || wn.language || wn.browserLanguage || wn.userLanguage;
    return lang;
  }

 

 
}

// function roundToTwo(num:number) {    
//   return +(Math.round(num + "e+2")  + "e-2");
// }
